<template>
    <client-page class="app--main">
        <div class="visual">
            <div class="background">
                <div class="visual__con">
                    <div class="text-ani-wrap">
                        <div class="text-ani mb-14 mb-lg-30">
                            <h2 class="main-tit visual__tit">
                                Global Productivity & Eco-Friendly
                            </h2>
                        </div>
                        <div class="text-ani">
                            <p class="visual__txt">
                                Every year, Meitextile takes advantage of the strength of R&D to keep pace with market trends with
                            </p>
                        </div>
                        <div class="text-ani">
                            <p class="visual__txt">
                                global productivity and fast response. We are also working hard to develop eco-friendly and
                            </p>
                        </div>
                        <div class="text-ani">
                            <p class="visual__txt">
                                reusable fabrics for sustainable development.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="video-bg">
                    <video playsinline muted loop autoplay poster="/images/main/visual-poster.jpg" class="video-bg__video">
                        <source src="/images/main/visual.mp4" type="video/mp4" />
                        <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                    </video>
                </div>
            </div>
        </div>

        <div class="main-contents">
            <section class="main-section main-section--first">
                <v-container>
                    <div class="prd-slide">
                        <div class="swiper-container">
                            <div class="swiper-control">
                                <div class="control-top">
                                    <h2 class="main-tit mb-lg-46 mb-xl-92" data-aos="fade-up">Product</h2>
                                    <div class="pagination"></div>
                                </div>
                                <div class="control-bottom">
                                    <v-btn icon tile large color="white" class="prev-btn"><i class="icon icon-left-arrow"></i></v-btn>
                                    <v-btn icon tile large color="white" class="next-btn"><i class="icon icon-right-arrow"></i></v-btn>
                                </div>
                            </div>
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <main-product link="/product/organic" mainImage="/images/main/prd-1.jpg" slideImage1="/images/main/prd-1-1.jpg" slideImage2="/images/main/prd-1-2.jpg" slideImage3="/images/main/prd-1-3.jpg" slideImage4="/images/main/prd-1-4.jpg" slideImage5="/images/main/prd-1-5.jpg" tit="Organic Line">
                                        Organic cotton, Better cotton, Bamboo, Recycled poly, Sorona , Eco <br class="d-none d-xl-block" />
                                        Vero, etc. All we must care about the Environment. Accordingly, we <br class="d-none d-xl-block" />
                                        are working with factories with certification. Join Meitex to protect <br class="d-none d-xl-block" />
                                        the environment!
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/product/sports" mainImage="/images/main/prd-2.jpg" slideImage1="/images/main/prd-2-1.jpg" slideImage2="/images/main/prd-2-2.jpg" slideImage3="/images/main/prd-2-3.jpg" tit="High Function Sports Line">
                                        Moisture-repellent/proof, Cooling/Heating function helps <br class="d-none d-xl-block" />
                                        consumer lives a healthy life. These functions starts with <br class="d-none d-xl-block" />
                                        high-quality yarn and construction of fabric. Discover a variety of <br class="d-none d-xl-block" />
                                        silhouettes and fabrications that enrich your life.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/product/active" mainImage="/images/main/prd-3.jpg" slideImage1="/images/main/prd-3-1.jpg" slideImage2="/images/main/prd-3-2.jpg" slideImage3="/images/main/prd-3-3.jpg" slideImage4="/images/main/prd-3-4.jpg" slideImage5="/images/main/prd-3-5.jpg" tit="Active & Legging line">
                                        Single/Double knit with printing and foil design, Special pattern with <br class="d-none d-xl-block" />
                                        Embossing, Very stretchy and recoverable quality. We have a lot of <br class="d-none d-xl-block" />
                                        experience and buyers for these sports & Legging items. Offer your <br class="d-none d-xl-block" />
                                        customers affordable and high-quality clothing.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/product/cotton" mainImage="/images/main/prd-4.jpg" slideImage1="/images/main/prd-4-1.jpg" slideImage2="/images/main/prd-4-2.jpg" slideImage3="/images/main/prd-4-3.jpg" slideImage4="/images/main/prd-4-4.jpg" slideImage5="/images/main/prd-4-5.jpg" tit="Cotton & Basic Line">
                                        Single/Double Knit, Rib, Terry, Tricot with BCI, US, Organic cotton and <br class="d-none d-xl-block" />
                                        blended fiber. From premium cotton fabrics to affordable options. <br class="d-none d-xl-block" />
                                        We produce any basic knit item with reasonable price.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/product/fleece" mainImage="/images/main/prd-5.jpg" slideImage1="/images/main/prd-5-1.jpg" slideImage2="/images/main/prd-5-2.jpg" slideImage3="/images/main/prd-5-3.jpg" slideImage4="/images/main/prd-5-4.jpg" slideImage5="/images/main/prd-5-5.jpg" tit="Fleece & Sherpa Line">
                                        Sherpa with short/long pile, Polar fleece, Mink Fleece, Terry Fleece, <br class="d-none d-xl-block" />
                                        Velour, Brushed Knit, etc. We have a lot of experience with synthetic <br class="d-none d-xl-block" />
                                        blend sherpa and fleece fabrics. Also have special strengths of <br class="d-none d-xl-block" />
                                        price and quality.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/product/novelty" mainImage="/images/main/prd-6.jpg" slideImage1="/images/main/prd-6-1.jpg" slideImage2="/images/main/prd-6-2.jpg" slideImage3="/images/main/prd-6-3.jpg" slideImage4="/images/main/prd-6-4.jpg" slideImage5="/images/main/prd-6-5.jpg" tit="Novelty Line">
                                        Special finished velvet with burn out & novelty printing. Jacquard & <br class="d-none d-xl-block" />
                                        Emboss fabric with various patterns. Delicate flocking mesh with <br class="d-none d-xl-block" />
                                        luxurious printing. Our R&D handles these items very skillfully. You <br class="d-none d-xl-block" />
                                        can meet special items that you can't find anywhere else.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/product/Comfortable" mainImage="/images/main/prd-7.jpg" slideImage1="/images/main/prd-7-1.jpg" slideImage2="/images/main/prd-7-2.jpg" slideImage3="/images/main/prd-7-3.jpg" slideImage4="/images/main/prd-7-4.jpg" slideImage5="/images/main/prd-7-5.jpg" tit="Comfortable & Cozy Line">
                                        Single, Towel Terry, Fleece, Texture etc, Variety structure with brush effect. <br class="d-none d-xl-block" />
                                        From home to outside, Our soft knit line gives you comfort & cozy feeling you need. can meet special items that you can't find anywhere else.
                                    </main-product>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-container>
            </section>
            <section class="main-section main-section--last">
                <v-container>
                    <h2 class="main-tit text-center" data-aos="fade-up">Partner Brand</h2>
                    <v-row>
                        <v-col cols="6" md="3" v-for="(banner, idx) in banners" :key="idx">
                            <div class="partner-thum-wrap">
                                <v-img class="partner-thum" :src="banner.slides[0].image"></v-img>
                            </div>
                        </v-col>
                    </v-row>

                    <div id="moreView" class="mt-10 mt-lg-24">
                        <v-row>
                            <v-col cols="6" md="3" v-for="(banner, idx) in banners2" :key="idx">
                                <div class="partner-thum-wrap">
                                    <v-img class="partner-thum" :src="banner.slides[0].image"></v-img>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="d-flex justify-center mt-40 mt-lg-80">
                        <div id="moreBtn">
                            <v-btn outlined color="primary" class="min-w-160px min-w-lg-200px" @click="add">View All <span class="ml-6 ml-lg-10 plus more-view-btn"></span></v-btn>
                        </div>
                    </div>
                </v-container>
            </section>
        </div>

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import api from "@/api";

import Swiper from "swiper/bundle";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainProduct from "@/components/client/main/main-product.vue";

export default {
    components: {
        ClientPage,
        PopupLayer,
        MainProduct,
    },
    mounted: function() {
        this.getBrand();
        setTimeout(() => {
            AOS.init({
                once: false,
                offset: 240,
                duration: 500,
                throttleDelay: 100,
                easing: "ease-in-out",
                anchorPlacement: "top-center",
            });
            this.init();
        }, 100);
    },
    data() {
        return {
            banners: {},
            banners2: {},
        };
    },
    methods: {
        async getBrand() {
            let { banners } = await api.v1.banners.gets({ headers: { limit: 16 } });
            this.banners = banners;
            console.log(this.banners);
        },
        async init() {
            this.$nextTick(() => {
                //prd-slide
                this.$nextTick(() => {
                    this.swiper = new Swiper(".prd-slide .swiper-container", {
                        allowTouchMove: true,
                        spaceBetween: 100,
                        slidesPerView: 1,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                        },
                        speed: 500,
                        loop: true,
                        pagination: {
                            el: ".prd-slide .pagination",
                            clickable: true,
                            renderBullet: function(index, className) {
                                return '<span class="' + className + '"> 0' + (index + 1) + "</span>";
                            },
                        },
                        navigation: {
                            nextEl: ".prd-slide .next-btn",
                            prevEl: ".prd-slide .prev-btn",
                        },
                        breakpoints: {
                            1200: {
                                slidesPerView: 2,
                            },
                        },
                    });
                });

                // moreview
                const moreView = document.getElementById("moreView");
                document.getElementById("moreBtn").onclick = function() {
                    var className = " " + moreView.className + " ";

                    if (~className.indexOf(" active ")) {
                        moreView.className = className.replace(" active ", " ");
                    } else {
                        moreView.className += " active ";
                    }
                };
            });
        },
        async add() {
            let { banners } = await api.v1.banners.gets({ headers: { skip: 16 } });
            this.banners2 = banners;
            console.log(this.banners2);
        },
    },
};
</script>

<style lang="scss" scoped>
.main-contents {
    position: relative;
}
.main-contents::before {
    content: "";
    display: block;
    position: absolute;
    width: 100px;
    height: 100%;
    background-color: #f7f8f9;
    left: 0;
    top: 0;
    z-index: 0;
}

.main-contents .main-section {
    position: relative;
    z-index: 1;
}

@media (min-width: 576px) {
    .main-contents::before {
        width: 200px;
    }
}
@media (min-width: 768px) {
    .main-contents::before {
        width: 360px;
    }
}
@media (min-width: 1024px) {
    .main-contents::before {
        width: 420px;
    }
}
@media (min-width: 1200px) {
    .main-contents::before {
        width: 540px;
    }
}

#moreView {
    overflow: hidden;
    max-height: 0;
    transition: 1.5s linear;
}
#moreView.active {
    max-height: 100vw;
}
</style>
